import { makeStyles } from '@material-ui/core/styles';

const useFieldStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.container.dark,
    color: theme.palette.text.onDark,
    fontSize: '0.9rem',
    textAlign: 'center',
    padding: '0.5rem 1.5rem',
    marginTop: '4.95rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'absolute',
    left: 0,
    right: 0,
  },
}));

export default useFieldStyles;
